import { PlannerGroupType } from '@ece-models/planner-group-type.enum';
import { PlannerCardThumbnailModel } from './planner-card-thumbnail.model';

export class PlannerGroupThumbnailModel {
  blockDescription: string = undefined;
  plannerGroupId: string = undefined;
  groupName: string = undefined;
  skillArea: string = undefined;
  icon: string = undefined; // emoji unicode
  groupType?: PlannerGroupType = undefined;


  // Not from API
  plannerCardThumbnails: PlannerCardThumbnailModel[] = [];
  weight: number = undefined;
  weekDays: (PlannerCardThumbnailModel | null)[] = [];
}
